export default __webpack_public_path__ + "static/media/onboardingLogo.3a2b1531.png";